module.exports = __webpack_public_path__ + "media/images/new_cureus_logo_2024-9fcd6370531d3bf0d83e884853901ca7.png";